module.exports = __webpack_public_path__ + "media/images/pic/gallery/2020/ceremonia-herbaty-2ed3c033df0bb7ba4599736f2ad24287.jpg";